import { createConnectQueryKey, useMutation } from '@connectrpc/connect-query'
import { useQueryClient } from '@tanstack/react-query'

import { unsuspendMember } from '~/gen/proto/bff/v1/admin-BffAdminService_connectquery'
import { BffAdminService } from '~/gen/proto/bff/v1/admin_pb'
import { BffCommonService } from '~/gen/proto/bff/v1/common_pb'

export function useUnsuspendMember(
  memberId: string,
  onSuccess: () => void,
): ReturnType<typeof useMutation> {
  const queryClient = useQueryClient()

  return useMutation(unsuspendMember, {
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: createConnectQueryKey({
          schema: BffCommonService.method.listMembers,
          cardinality: 'finite',
        }),
      })
      void queryClient.refetchQueries({
        queryKey: createConnectQueryKey({
          schema: BffAdminService.method.getMember,
          input: { memberId: memberId },
          cardinality: 'finite',
        }),
      })

      onSuccess()
    },
  })
}
